module.exports = __webpack_public_path__ + "img/credit-card.e4396ca3.svg";